import React from 'react'

import { MenuProvider } from './src/hooks/menu-context'

export const wrapRootElement = ({ element }) => {
  return <MenuProvider>{element}</MenuProvider>
}
